import { Button, Col, Row, Typography } from "antd";
import { EditOutlined } from "@ant-design/icons";
import moment from "moment";

export default function TravellerCards({ selectPayloadData, handleEditClick }) {
    const travellerInfo = selectPayloadData?.bookings?.[0]?.passengers || [];

    const getTagColor = (paxType) => {
        switch (paxType) {
            case 1:
                return 'blue';
            case 2:
                return 'orange';
            case 3:
                return 'green';
            default:
                return 'gray';
        }
    };

    const { Title } = Typography;

    return (
        <div className="max-w-3xl mx-auto px-4">
            <div className="booking-details lastBorder">
                <div title="" className="traveller-card">
                    <div className="d-flex justify-content-between align-items-center">
                        <Title level={5} className='mt-2'>Review Details</Title>
                        <div className='d-flex justify-content-center py-3'>
                            <Button
                                onClick={handleEditClick}
                                className="btn btn-primary menu-block rounded m-auto d-flex align-items-center justify-content-center"
                            >
                                <EditOutlined />
                                Edit
                            </Button>
                        </div>
                    </div>

                    <Row gutter={16} style={{ overflowY: 'auto', maxHeight: '420px', padding: '5px 0' }}>
                        {travellerInfo?.map((traveller, index) => (
                            <Col key={index} xs={24}>
                                <div className="card traveller-info-card">
                                    <div className="card-header py-2">
                                        <h3 style={{ color: getTagColor(traveller.PaxType) }}>
                                            <b>{traveller.PaxType === 1 ? 'ADULT' : traveller.PaxType === 2 ? 'CHILD' : 'INFANT'}</b>
                                        </h3>
                                        <p>Traveller {index + 1}</p>
                                    </div>
                                    <div className="card-body">
                                        <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                            <span>Title:</span> <strong>{traveller?.Title || 'N/A'}</strong>
                                        </p>
                                        <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                            <span>First Name:</span> <strong>{traveller?.FirstName || 'N/A'}</strong>
                                        </p>
                                        <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                            <span>Last Name:</span> <strong>{traveller?.LastName || 'N/A'}</strong>
                                        </p>
                                        {traveller?.DateOfBirth && (
                                            <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                                <span>Date of Birth:</span> <strong>  {moment(traveller?.DateOfBirth).format("MMM DD, YYYY")}</strong>
                                            </p>
                                        )}
                                        {traveller?.PassportNo && (
                                            <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                                <span>Passport Number:</span> <strong>{traveller?.PassportNo}</strong>
                                            </p>
                                        )}
                                        {traveller?.PassportExpiry
                                            && (
                                                <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                                    <span>Passport Expiry Date   :</span> <strong>  {moment(traveller?.PassportExpiry).format("MMM DD, YYYY")}</strong>
                                                </p>
                                            )}
                                        {traveller?.CountryName && (
                                            <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                                <span>Nationality:</span> <strong>{traveller?.CountryName || 'N/A'}</strong>
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>
            </div>
        </div>
    );
}
